import { Controller, useFormContext } from "react-hook-form";
import {
    Autocomplete,
    AutocompleteItem,
    AutocompleteProps,
} from "@heroui/react";

function AutoCompleteInput({
    name,
    options,
    hideErrorMessage,
    ...props
}: {
    name: string;
    options: { id: string | number; description: string | number }[];
    hideErrorMessage?: boolean;
} & Partial<AutocompleteProps>) {
    const { control } = useFormContext();
    return (
        <Controller
            control={control}
            name={name}
            render={({
                field: { onBlur, onChange, value },
                fieldState: { error, invalid },
            }) => {
                return (
                    <Autocomplete
                        {...props}
                        onSelectionChange={(e) => {
                            onChange(e);
                            props.onSelectionChange?.(e);
                        }}
                        onBlur={onBlur}
                        name={name}
                        isInvalid={invalid}
                        errorMessage={
                            hideErrorMessage ? undefined : error?.message
                        }
                        selectedKey={value === undefined ? null : value}
                    >
                        {options.map((option) => (
                            <AutocompleteItem key={option.id}>
                                {option.description}
                            </AutocompleteItem>
                        ))}
                    </Autocomplete>
                );
            }}
        />
    );
}

export default AutoCompleteInput;
